import { asyncThunkCreator, buildCreateSlice } from '@reduxjs/toolkit';

export const createThunkSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});
